// import { PageModule } from 'data/generated/graphql';

// interface PageModuleTwoColumnProps {
//   pageModule: PageModule;
//   onChange: ((pageModule: PageModule) => void) | null;
// }

export const PageModuleTwoColumn = (/* { pageModule, onChange }: PageModuleTwoColumnProps */) => <></>;
